// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UAState } from './UAState';
import {
    UAStateFromJSON,
    UAStateFromJSONTyped,
    UAStateToJSON,
    UAStateToJSONTyped,
} from './UAState';
import type { UATransition } from './UATransition';
import {
    UATransitionFromJSON,
    UATransitionFromJSONTyped,
    UATransitionToJSON,
    UATransitionToJSONTyped,
} from './UATransition';

/**
 * 
 * @export
 * @interface MachineryItemState
 */
export interface MachineryItemState {
    /**
     * 
     */
    currentState: UAState;
    /**
     * 
     */
    lastTransition?: UATransition;
    /**
     * OPC UA StatusCode name of the CurrentState read.
     */
    statusCode?: string;
}



/**
 * Check if a given object implements the MachineryItemState interface.
 */
export function instanceOfMachineryItemState(value: object): value is MachineryItemState {
    if (!('currentState' in value) || value['currentState'] === undefined) return false;
    return true;
}

export function MachineryItemStateFromJSON(json: any): MachineryItemState {
    return MachineryItemStateFromJSONTyped(json, false);
}

export function MachineryItemStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineryItemState {
    if (json == null) {
        return json;
    }
    return {
        
        'currentState': UAStateFromJSON(json['currentState']),
        'lastTransition': json['lastTransition'] == null ? undefined : UATransitionFromJSON(json['lastTransition']),
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
    };
}

export function MachineryItemStateToJSON(json: any): MachineryItemState {
    return MachineryItemStateToJSONTyped(json, false);
}

export function MachineryItemStateToJSONTyped(value?: MachineryItemState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentState': UAStateToJSON(value['currentState']),
        'lastTransition': UATransitionToJSON(value['lastTransition']),
        'statusCode': value['statusCode'],
    };
}

